jQuery(document).ready(function($){

	//add helper text to the guest button on the customer accounts login page
    $('#template #guest form').after('<div class="helperText">* You can create a new customer account at the end of the checkout process.</div>');
    
    //product images
    zoomable($('#images #image a'));
    $('#images #thumbs a').each(function(){
	    $(this).unbind('click');
	    $(this).click(function(){
		    $('#images #image a').attr('href',$(this).attr('href'));
		    $('#images #image a img').attr('src',$(this).attr('href'));
		    zoomable($('#images #image a'));
		    return false;
	    });
    });
    
    function zoomable($element){
    	var elem = $element; //should be the wrapper for the image
    	var imgSrc = elem.attr('href');
    	var newImg = new Image();
    	newImg.onload = function() {
	    	var height = newImg.height;
	    	var width = newImg.width;
	    	//console.log('The image size is '+width+'*'+height+' and elem width is '+elem.width());
	    	if(width > elem.width()){
	    		//console.log('zoomed '+imgSrc);
	    		elem.find('img.zoomImg').remove();
		    	elem.addClass('zoom').zoom({
		    		url:imgSrc,
		    		callback: function(){
			    		$(this).colorbox({
			    			href: this.src,
			    			maxHeight: '92%'
			    		});
			    	}
		    	});
		    	elem.css('cursor','pointer');

	    	}else{
	    		//console.log('unzoomed '+imgSrc);
	    		elem.find('img.zoomImg').remove();
		    	elem.unbind('hover').removeClass('zoom');
		    	elem.click(function(){return false;}).unbind('click').css('cursor','default');
	    	}
	    }
	    newImg.src = imgSrc; // this must be done AFTER setting onload
    }
    
    
    // callback when a variant selector is updated.
    //image alt text has to be the same as the variant title 
    $('#variants select.single-option-selector').change(function() {
    	var variantImage = $(this).val();
    	if(variantImage && variantImage != '' && $('#images #thumbs img[alt="'+variantImage+'"]').length > 0){
    		var targetThumb = $('#images #thumbs img[alt="'+variantImage+'"]');
	    	var imgLarge = targetThumb.parent().attr('href');
	    	var img = targetThumb.attr('src');
	    	$('#images #image a').attr('href',imgLarge);
	    	$('#images #image a img').attr('src',imgLarge);
	    	zoomable($('#images #image a'));
	    	//console.log('should have worked '+ $('#images #image > a > img.first').attr('src') );
    	}else{
	    	//console.log('didnt find the associated img for '+variantImage);
    	}
    });
});
